import React from 'react';
import { FONT_MONO, FONT_SANS, IMG, SUPPORT_EMAIL } from './landingData';
import { USE_CASES } from './useCasesData';
import { useTemplatesLink } from './useLandingTheme';

const link: React.CSSProperties = { color: 'var(--hv-on-deep-dim)' };

export const LandingFooter: React.FC = () => {
    const templatesLink = useTemplatesLink();
    return (
    <footer style={{ color: 'var(--hv-on-deep-dim)', background: 'var(--hv-deep)' }}>
        <div className="hv-shell" style={{ maxWidth: 1280, margin: '0 auto', padding: '34px 28px', display: 'flex', alignItems: 'center', gap: 24, flexWrap: 'wrap' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 9, color: 'var(--hv-on-deep)' }}>
                <img src={IMG.logoDark} alt="HyVay" style={{ height: 22, width: 22, display: 'block', objectFit: 'cover' }} />
                <span style={{ fontFamily: FONT_SANS, fontSize: 17, fontWeight: 800 }}>HyVay</span>
            </div>
            <span style={{ fontFamily: FONT_MONO, fontSize: 10.5, letterSpacing: '0.02em' }}>© 2026 HyVay - PT Quality Agent Technologies. All rights reserved.</span>
            <div style={{ flex: 1 }} />
            <div style={{ display: 'flex', gap: 20, fontSize: 13, flexWrap: 'wrap' }}>
                <a href={`/use-cases/${USE_CASES[0].slug}`} className="hv-h-ondeep" style={link}>Use cases</a>
                <a {...templatesLink} className="hv-h-ondeep" style={link}>Templates</a>
                <a href="/docs" className="hv-h-ondeep" style={link}>Docs</a>
                <a href="/pricing" className="hv-h-ondeep" style={link}>Pricing</a>
                <a href="/faq" className="hv-h-ondeep" style={link}>FAQ</a>
                <a href={`mailto:${SUPPORT_EMAIL}`} className="hv-h-ondeep" style={link}>Support</a>
                <a href="/about" className="hv-h-ondeep" style={link}>About</a>
                <a href="/terms" className="hv-h-ondeep" style={link}>Terms</a>
                <a href="/privacy" className="hv-h-ondeep" style={link}>Privacy</a>
            </div>
        </div>
    </footer>
    );
};
